var React = require('react');

function BagIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"style":{"stroke":"#454545","strokeWidth":"0.1px","strokeDasharray":"none","strokeLinecap":"butt","strokeDashoffset":"0","strokeLinejoin":"miter","strokeMiterlimit":"4","fill":"#454545","fillRule":"nonzero","opacity":"1"},"vectorEffect":"non-scaling-stroke","d":"M88.09 35.64c-.13-1.9-1.31-3.18-3.02-3.18-1.75 0-2.95 1.28-3.07 3.18h-1.45v8.99h8.99v-8.99h-1.45zm-3.05-2.55c1.32 0 2.17.95 2.27 2.55h-4.54c.1-1.6.94-2.55 2.27-2.55zm3.84 10.89h-7.69v-7.69h7.69v7.69z"}));
}

BagIcon.defaultProps = {"width":"13px","height":"17px","viewBox":"80.055 31.965 9.99 13.17","xmlSpace":"preserve"};

module.exports = BagIcon;

BagIcon.default = BagIcon;
